export function getHttpStatus(errorResponse: unknown): number | undefined {
  if (!errorResponse || typeof errorResponse !== 'object') {
    return undefined;
  }

  const response = errorResponse as {
    response?: { status?: unknown };
    status?: unknown;
  };
  const status = response.response?.status ?? response.status;

  return typeof status === 'number' ? status : undefined;
}
